import React from 'react';

function RightBar({ children }) {
  return (
    <div className=" h-screen top-32 right-0 fixed w-1/5 pr-6 ">{children}</div>
  );
}

export default RightBar;
